import { Editor } from 'grapesjs';
import { ReferralDataRenderer, ReferralTypeEnum } from '@loyalty/editor-components';
import { EditorComponentDefinition } from '../types';
import { ReferralWidgetTraits } from './ReferralWidgetTraits';
import { Toolbar, buildParticipantContextFromGrape } from '../../utils';
import { referralCodesIcon } from '../../../../shared/icons';

const CLASSNAME = 'qlfeditor-referral-data';

export const referralDataGrapesComponentDefinition: EditorComponentDefinition = {
  id: 'referral-data',
  icon: referralCodesIcon,
  getLabel: ({ t }) => t('editor.component.referral'),
  component: ReferralDataGrapesComponent,
  traits: {
    form: ReferralWidgetTraits,
  },
  copyPasteHelper: (element, context) => {
    element.attributes.referralType = ReferralTypeEnum.CODE;
  },
};

export function ReferralDataGrapesComponent(editor: Editor) {
  const i18n = editor.I18n;

  editor.DomComponents.addType(referralDataGrapesComponentDefinition.id, {
    isComponent: (el: HTMLElement) => {
      return el.tagName === 'DIV' && el.classList.contains(CLASSNAME);
    },
    model: {
      defaults: {
        tagName: 'div',
        category: 'content',
        attributes: {
          class: 'qlfeditor-referral-data--root',
          referralType: ReferralTypeEnum.P_LINK,
          showOnlyButton: true,
        },
        traits: [],
        content: '',
        droppable: false,
        draggable: false,
        removable: false,
        copyable: false,
      },
      initToolbar: Toolbar,
      init() {
        this.listenTo(this, 'change:attributes', () => setTimeout(() => this.view?.onRender()));
      },
      toHTML(): string {
        return ReferralDataRenderer(
          {
            state: editor.Config?.context.widgetState,
            options: {
              id: this.getId(),
              attributes: this.getAttributes(),
              i18nAttributes: this.attributes.i18nAttributes || {},
            },
            context: buildParticipantContextFromGrape(i18n),
          },
          editor.Canvas.getDocument(),
        );
      },
    },
    view: {
      onRender() {
        const { el, model } = this;
        el.innerHTML = model.toHTML();
      },
    },
  });
}
